<span class="box-message">
  URL copied...!!!
</span>
